import React from 'react';

import { TimeRange } from '@fullstory/proto/fs/api/segment';
import { FormattedMessage, defineMessage, useIntl } from 'react-intl';
import { useRetentionContactButton } from '../../hooks/useRetentionContactButton';
import { useSelector } from 'react-redux';
import { fullstorySelectors } from '@fullstory/redux';
import moment from 'moment';

const { getRetentionTimestamp, getPlaybackRetentionTimestamp } = fullstorySelectors;

const pluralMonthsMessage = defineMessage({
  defaultMessage: '{months, plural, one {1 month} other {# months}}',
  id: '8B9SET',
  description: 'Pluralize a number of months',
});

export const usePlaylistRetentionError = (timeRange?: TimeRange | null) => {
  const intl = useIntl();

  const contactButton = useRetentionContactButton();
  const analyticsRetention = useSelector(getRetentionTimestamp);
  const playbackRetention = useSelector(getPlaybackRetentionTimestamp);

  const retentionError = timeRange && new Date(timeRange.endTime) < new Date(playbackRetention);
  if (!retentionError) {
    return {
      hasError: false,
      errorMessage: null,
    };
  }

  const analyticsDiff = moment().diff(analyticsRetention);
  const analyticsMonths = Math.round(moment.duration(analyticsDiff).asMonths());
  const analyticsMonthsMessage = intl.formatMessage(pluralMonthsMessage, {
    months: analyticsMonths,
  });

  const playbackDiff = moment().diff(playbackRetention);
  const playbackMonths = Math.round(moment.duration(playbackDiff).asMonths());
  const playbackMonthsMessage = intl.formatMessage(pluralMonthsMessage, { months: playbackMonths });

  return {
    hasError: true,
    errorMessage: (
      <FormattedMessage
        defaultMessage="Your plan currently includes {analyticsMonthsMessage} of analytics retention and
                  {playbackMonthsMessage} of session replay retention. Your selected time period
                  falls outside of your session replay retention plan. Please {contactButton} to upgrade."
        id="hCg6LC"
        description="The monthsMessage arguments are separately translated pluralizations of a number of months. Ex: '1 month' or '6 months'"
        values={{
          analyticsMonthsMessage,
          playbackMonthsMessage,
          contactButton,
        }}
      />
    ),
  };
};
